import { invariant } from '../debug/invariant.util';

interface ISizeProps {
  theme: {
    _window_size: {
      width: number,
      height: number
    }
  };
}

function isSizeProps(props: any): props is ISizeProps {
  return props.theme && props.theme._window_size !== undefined;
}

export class SizeHelper {
  static get fullWidth() {
    return (props: any) => {
      if (isSizeProps(props)) {
        return props.theme._window_size.width ? `${props.theme._window_size.width}px` : '100vw';
      }
      invariant(false, 'Wrong prop type for size helper', props);
      return '';
    };
  }

  static get fullHeight() {
    return (props: any) => {
      if (isSizeProps(props)) {
        return props.theme._window_size.height ? `${props.theme._window_size.height}px` : '100vh';
      }
      invariant(false, 'Wrong prop type for size helper', props);
      return '';
    };
  }
}
